const SEO_CONFIG = {
  title: 'LP Time Machine',
  description: 'Pick your winning liquidity pools with ease. Powered with real historical performance and yield farming rewards marked to USD, you can ditch misleading APYs and focus on screening liquidity pools that make real return with our metrics.',
  author: 'single_finance',
  keywords: 'Single Finance, DeFi, LP Time Machine',
};

export default SEO_CONFIG;
